module.exports = __webpack_public_path__ + "static/media/apps.b1b6114e.svg";